import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import authReducer from './auth';
import dashboardReducer from './dashboard';
import customerReducer from './customerReducer';
import serverReducer from './serverReducer';
import userReducer from './userReducer';

export default combineReducers({
  form: formReducer,
  auth: authReducer,
  dash: dashboardReducer,
  customerState: customerReducer,
  serverState: serverReducer,
  userState:userReducer
});

